module.exports = __webpack_public_path__ + "static/cosmoderm-9186c14550f9cee74822d7d700cbc94e.png";